module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Extrabold.fe03db96.ttf";